module.exports = __webpack_public_path__ + "img/emoji_35.0333b5e5.png";